/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBCOMMODITYTYPE = 'GETCLUBCOMMODITYTYPE'





// WEBPACK FOOTER //
// ./src/containers/ClubCommodityType/constants.js